<template>
        <UICard class="clientNavigation w-auto h-full border-none p-4 ring-0 shadow-none pr-10">
            <h2 class="uppercase mb-2 contentlist-headline text-text-secondary font-bold">Menu</h2>
            <SideNavigationSubmenuBtn v-for="(item, index) in useClientNavigation" :link="item" >
            </SideNavigationSubmenuBtn>
        </UICard>
</template>

<script setup lang="ts">
import type { ClientList } from '~/types/api/user/index'
const useSelectedClient = useState<ClientList>('selectedClient')
const useClientNavigation = useState('clientNavigation');

import { API } from "~/utils/api";
const api = new API()
const { data } = await useAsyncData(
    () => `clientNavigation-${useSelectedClient.value?.client_id}`,
    () => api.client(useSelectedClient.value?.client_id).getClientNavigation(),
)
useClientNavigation.value = data;
</script>

<style scoped lang="scss">
@reference "~/assets/css/main.css";
:deep( .router-link-active){
@apply text-text-primary bg-primary/10 font-bold;
}
.submenuBtn-main .router-link-exact-active{
@apply text-text-primary bg-primary/10 font-bold;
}

</style>